import { Camera, Film, Users, Building2 } from "lucide-react";
import { services } from "../data/mock";

const iconFor = (id) => {
  switch (id) {
    case "s1":
      return Users;
    case "s2":
      return Camera;
    case "s3":
      return Building2;
    case "s4":
      return Film;
    default:
      return Camera;
  }
};

const Services = () => {
  return (
    <section id="services" className="py-24 md:py-36">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-12 gap-10 items-start">
          <div className="col-span-12 md:col-span-4 reveal md:sticky md:top-28">
            <div className="text-xs tracking-[0.25em] uppercase text-[#8B6F47] mb-4">(04) Services</div>
            <h2 className="font-display text-[48px] md:text-[64px] leading-[0.98] tracking-tight">
              What I <span className="italic-display">make</span>.
            </h2>
            <p className="mt-6 text-[15px] leading-relaxed text-[#1A1A1A]/70 max-w-sm">
              Four quiet specialties, one shared approach: honest, cinematic, and built around you.
              Custom quotes are always welcome — every story deserves its own treatment.
            </p>
          </div>

          <div className="col-span-12 md:col-span-8 divide-y divide-[#1A1A1A]/15 border-y border-[#1A1A1A]/15">
            {services.map((s, i) => {
              const Icon = iconFor(s.id);
              return (
                <div
                  key={s.id}
                  className="group py-8 md:py-10 flex flex-col md:flex-row md:items-center gap-6 md:gap-10 reveal"
                >
                  <div className="text-[11px] tracking-[0.25em] uppercase text-[#1A1A1A]/50 w-10">
                    0{i + 1}
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center gap-4">
                      <Icon size={22} className="text-[#8B6F47]" />
                      <h3 className="font-display text-3xl md:text-4xl leading-none">{s.title}</h3>
                    </div>
                    <p className="mt-3 text-[15px] leading-relaxed text-[#1A1A1A]/70 max-w-xl">
                      {s.desc}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
